export default {
  'invoiceTaxes.label.icms': 'ICMS Value',
  'invoiceTaxes.label.icmsSt': 'ICMS ST Value',
  'invoiceTaxes.label.ipi': 'IPI Value',
  'invoiceTaxes.label.issqn': 'ISSQN Value',
  'invoiceTaxes.label.fcp': 'FCP Value',
  'invoiceTaxes.label.fcpSt': 'FCP ST Value',
  'invoiceTaxes.label.fcpStRetained': 'Retained FCP ST Value',
  'invoiceTaxes.label.pis': 'PIS Value',
  'invoiceTaxes.label.pisSt': 'PIS ST Value',
  'invoiceTaxes.label.pisRetained': 'Retained PIS Value',
  'invoiceTaxes.label.cofins': 'COFINS Value',
  'invoiceTaxes.label.cofinsSt': 'COFINS ST Value',
  'invoiceTaxes.label.cofinsRetained': 'Retained COFINS Value',

  'invoiceTaxes.button.calculate': 'Calculate Tribute',

  'invoiceTaxes.label.others': 'Others',
  'invoiceTaxes.label.issqn': 'ISSQN',
  'invoiceTaxes.label.issqnRate': 'ISSQN Rate',
  'invoiceTaxes.label.issqnCalculationBasis': 'ISSQN Calculation Basis',
  'invoiceTaxes.label.issqnValue': 'ISSQN Value',
  'invoiceTaxes.label.inssValue': 'INSS Value',
  'invoiceTaxes.label.csllValue': 'CSLL Value',
  'invoiceTaxes.label.irValue': 'IR Value',
};
